import { useEffect, useRef, useState } from 'react'

import { MetaData, fetchMetaData } from '../types/meta'

export const useFetchMetaData = (entity: string) => {
  const [metaData, setMetaData] = useState<MetaData | null>(null)
  const hasFetchedData = useRef(false)

  useEffect(() => {
    const getData = async () => {
      if (!hasFetchedData.current) {
        try {
          const data = await fetchMetaData(entity)
          setMetaData(data)
          hasFetchedData.current = true
        } catch (error) {
          console.error(`Error fetching ${entity} data:`, error)
        }
      }
    }
    getData()
  }, [entity])

  return metaData
}
